import { z } from 'zod';

import zodLocales from 'common/zod/locales';

const applicantSchema = z.object({
  email: z
    .string()
    .min(1, {
      message: zodLocales.errors.required,
    })
    .email({
      message: zodLocales.errors.invalidEmail,
    }),
  id: z.string(),
});

const confirmBeneficiariesFormSchema = z.object({
  applicants: z.array(applicantSchema),
});

export type ConfirmBeneficiariesFormSchema = z.input<
  typeof confirmBeneficiariesFormSchema
>;

export type BeneficiaryCardFormSchemaValid = z.infer<
  typeof confirmBeneficiariesFormSchema
>;

export default confirmBeneficiariesFormSchema;
